import React from 'react';
import PropTypes from 'prop-types';
import { Grid, TextField, Typography } from '@material-ui/core';
import { Field, reduxForm } from 'redux-form';
import ConfirmationButtons from '../General/ConfirmationButtons';
import { isMobile } from 'react-device-detect';
import { history } from '../../helpers/history';

// Función de validación para Redux-Form
const validate = (values) => {
    const errors = {};
    if (!values.description) {
        errors.description = 'Este campo es requerido.';
    }
    return errors;
};

// Renderiza un TextField compatible con Redux-Form
const renderTextField = ({ input, label, meta: { touched, error } }) => (
    <TextField
        {...input}
        label={label}
        error={touched && !!error}
        helperText={touched && error ? error : ' '}
        fullWidth
        size={isMobile ? 'small' : 'medium'}
        autoComplete="off"
    />
);

const SendPayrollForm = ({ handleSubmit, children, dataTotal }) => {

    return (
        <form onSubmit={handleSubmit} autoComplete="off" style={{ paddingInline: '1rem', paddingBottom: '32px' }}>
            <Grid container spacing={2} justifyContent="space-evenly" direction="column">
                <Grid item xs={12} style={{ paddingBottom: 3, paddingTop: 2 }}>
                    <Typography component="span" style={{ fontWeight: 'bold', color: 'black' }}>
                        Total: $
                    </Typography>
                    <Typography component="span" style={{ fontWeight: 'bold', marginLeft: 0.5 }}>
                        {dataTotal.toFixed(2)}
                    </Typography>
                </Grid>

                <Grid item xs={12} style={{ paddingBottom: 3, paddingTop: 2 }}>
                    <Field name="description" component={renderTextField} label="Descripción" />
                </Grid>

                <Grid item xs={12}>
                    {children}
                </Grid>

                <br />
                <Grid container justifyContent="space-evenly">
                    <ConfirmationButtons handleClickCancel={() => history.push('/')} padding="0" justifyContent="space-evenly" />
                </Grid>
            </Grid>
        </form>
    );
};

SendPayrollForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    dataTotal: PropTypes.number.isRequired,
};

// Conectamos el formulario a Redux
export default reduxForm({
    form: 'sendPayrollForm',
    validate,
})(SendPayrollForm);
